export default "__VITE_ASSET__Bk0JZ7L9__"